import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgIntersexGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M34.68 9.181a.763.763 0 0 0-1.01.02l-.03.03c-.3.26-2.57 2.11-6.24 1.17a.75.75 0 0 0-.37 1.45c1.47.38 2.76.37 3.84.19l-4.65 4.7a8.027 8.027 0 0 0-5.16-1.88c-4.45.01-8.06 3.63-8.06 8.07 0 4.19 3.21 7.64 7.31 8.02v3.36h-2.3c-.41 0-.75.34-.75.75s.34.74.75.74h2.29v2.38c0 .41.34.75.75.75s.75-.34.75-.75v-2.38h2.29c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-2.28v-3.36c4.09-.38 7.3-3.83 7.3-8.02 0-1.94-.69-3.72-1.83-5.11l4.81-4.86c-.09 1.03.02 2.25.51 3.69.11.31.4.5.71.5a.75.75 0 0 0 .71-1c-1.33-3.81.61-5.77.7-5.86h-.02c.07-.06.1-.1.1-.1.23-.31.17-.74-.12-1Zm-13.62 20.3c-3.61 0-6.56-2.94-6.56-6.56 0-3.61 2.94-6.55 6.56-6.55a6.56 6.56 0 0 1 6.55 6.55c0 3.62-2.94 6.56-6.55 6.56Z",
    fill: "currentColor"
  }));
}

export { SvgIntersexGlyphSecondary as default };
